import type { FaireProductEntity } from "../../entity_types/product";

export const p_2a99kd9v38: FaireProductEntity = {
  token: "p_2a99kd9v38",
  type: "product",
  name: "apple watercolor fruit wall art print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c56070ef35b160d0dbe19a8318f3e4554410492b4d7f2d296cac67ec92d21395.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    'Display this lovely apple print throughout your home.\n\n• 8"x10" print of original watercolor artwork by Emily Lex\n• Printed in full color on thick, superfine paper\n• Packaged in a clear protective sleeve with chipboard backing\n• Frame and mat not included',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:53.808Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
